import { render, staticRenderFns } from "./JournalTablePage.vue?vue&type=template&id=5b9cb9dd&scoped=true"
import script from "./JournalTablePage.vue?vue&type=script&lang=js"
export * from "./JournalTablePage.vue?vue&type=script&lang=js"
import style0 from "./JournalTablePage.vue?vue&type=style&index=0&id=5b9cb9dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9cb9dd",
  null
  
)

export default component.exports